var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8047",
    "data-name": "\\uADF8\\uB8F9 8047",
    transform: "translate(839 15521)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8273",
    "data-name": "\\uADF8\\uB8F9 8273"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_9047",
    "data-name": "\\uC0AC\\uAC01\\uD615 9047",
    transform: "translate(-839 -15521)",
    fill: "#fff",
    stroke: "#ccc",
    strokeWidth: 1,
    strokeDasharray: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 99,
    height: 99,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8046",
    "data-name": "\\uADF8\\uB8F9 8046",
    transform: "translate(15.5 8.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_126",
    "data-name": "\\uC120 126",
    x2: 30,
    transform: "translate(-819.5 -15479.5)",
    fill: "none",
    stroke: "#ddd",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_127",
    "data-name": "\\uC120 127",
    y2: 30,
    transform: "translate(-804.5 -15494.5)",
    fill: "none",
    stroke: "#ddd",
    strokeWidth: 1
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddImg);
export default __webpack_public_path__ + "static/media/add_img.8d9063e6fa3ac3280a848a9b42a188e1.svg";
export { ForwardRef as ReactComponent };